define([], function() {
    'use strict';
    /* inject requires for bower dependencies */
    // bower:

    require('jquery');

    require('angular');

    require('angular-aria');

    require('angular-animate');

    require('angular-sanitize');

    require('angular-touch');

    require('es5-shim');

    require('bowser');

    require('underscore');

    require('ec-style-base');

    require('ec-style-grid');

    require('select2');

    require('d3');

    require('asterix-core');

    require('asterix-ng');

    require('ec-input');

    require('ec-container');

    require('ec-button');

    require('ec-chosen');

    require('ec-combo-box');

    require('ec-tabs');

    require('ec-paginator');

    require('ec-portfolio-data');

    require('ec-report-builder');

    require('ec-autocomplete');

    require('ec-table');

    require('ec-performance-graph');

    require('ec-hypothetical-growth');

    // endbower

    var morningstar = require('morningstar');

    morningstar.initBundle = function(appConfigOverrides, configOptions) {

        var appConfig = {};

        morningstar.asterix.bootstrap.init({
            appConfig: morningstar.asterix.extend(true, {}, appConfig, appConfigOverrides),
            configOptions: configOptions || {}
        });
    };

    require('./_entrypoint');
});



// WEBPACK FOOTER //
// ./components/multiple-chart/src/js/_bundle.js